import { render, staticRenderFns } from "./Reset2FA.vue?vue&type=template&id=780bfb6f&scoped=true"
import script from "./Reset2FA.vue?vue&type=script&lang=js"
export * from "./Reset2FA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780bfb6f",
  null
  
)

export default component.exports